import { Button, Grid, Typography } from "@mui/material";
import { Formik, Field, Form } from "formik";
import { TextField } from "formik-mui";

import { useTranslation } from "react-i18next";
import { APIError } from "src/types";
import { useLoginlinkSchema } from "src/schemas/loginlink.schema";
import { ServerErrors } from "src/components/form-components/ServerErrors";
import { ButtonGrid } from "src/components/form-components/ButtonGrid";
import { ButtonLoading } from "src/components/ButtonLoading";

export type LoginLinkFormData = { password: string };

interface Props {
  onClose: () => void;
  onSubmit: (values: LoginLinkFormData) => void;
  isLoading: boolean;
  errors?: APIError[] | Error | null;
}

export function LoginLinkForm(props: Props) {
  const { t } = useTranslation();
  const validationSchema = useLoginlinkSchema();
  return render();

  function render() {
    return (
      <Formik
        initialValues={{ password: "", passwordConfirmation: "" }}
        validationSchema={validationSchema}
        onSubmit={props.onSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography></Typography>
              </Grid>

              <Grid item xs={12}>
                <Field
                  component={TextField}
                  name="password"
                  label={t("label.password")}
                  type="password"
                  variant="standard"
                />
              </Grid>

              <Grid item xs={12}>
                <Field
                  component={TextField}
                  name="passwordConfirmation"
                  label={t("label.passwordConfirmation")}
                  type="password"
                  variant="standard"
                />
              </Grid>

              {props.errors && (
                <Grid item xs={12}>
                  {/* @TODO: this should handle APIError and Error differently */}
                  <ServerErrors data={props.errors as APIError[]} />
                </Grid>
              )}

              <ButtonGrid container item xs={12} sx={{ justifyContent: "flex-end" }}>
                <Button variant="text" onClick={props.onClose}>
                  {t("label.cancel")}
                </Button>
                <ButtonLoading
                  isLoading={isSubmitting || props.isLoading}
                  type="submit"
                  color="primary"
                  variant="contained"
                >
                  {t("label.save")}
                </ButtonLoading>
              </ButtonGrid>
            </Grid>
          </Form>
        )}
      </Formik>
    );
  }
}
